<label *ngIf="label" [attr.for]="id" class="mb-2">
  {{ label }}<sup *ngIf="required" class="text-danger ms-1">*</sup>
</label>
<select
  class="form-select"
  [ngClass]="classes"
  aria-label="Disabled select example"
  [attr.id]="id"
  (change)="itemSelected($event)"
  (blur)="blur.emit()"
  [class.text-capitalize]="isCapitalize"
>
  <option
    *ngIf="placeholder"
    value=""
    disabled
    [selected]="!selectedItem || !selectedItem.value"
  >
    {{ placeholder }}
  </option>
  <option
    *ngFor="let item of items"
    [value]="item.value"
    [selected]="selectedItem && selectedItem.value === item?.value"
    [class.text-capitalize]="isCapitalize"
  >
    {{ item.label }}
  </option>
</select>
